const escapeHtml = (text: string) => text.replace(/</g, '&lt;').replace(/>/g, '&gt;')

export default escapeHtml
